/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDeleteIntegrationResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createGetIntegrationResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createUpdateIntegrationResponseFromDiscriminatorValue, serializeUpdateIntegrationRequest, serializeUpdateIntegrationResponse, type DeleteIntegrationResponse, type ErrorResponse, type GetIntegrationResponse, type InternalErrorResponse, type UpdateIntegrationRequest, type UpdateIntegrationResponse } from '../../../../../models/index.js';
// @ts-ignore
import { RotateSecretsRequestBuilderRequestsMetadata, type RotateSecretsRequestBuilder } from './rotateSecrets/index.js';
// @ts-ignore
import { TestRequestBuilderRequestsMetadata, type TestRequestBuilder } from './test/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/{organizationId}/integrations/{integrationId}
 */
export interface WithIntegrationItemRequestBuilder extends BaseRequestBuilder<WithIntegrationItemRequestBuilder> {
    /**
     * The rotateSecrets property
     */
    get rotateSecrets(): RotateSecretsRequestBuilder;
    /**
     * The test property
     */
    get test(): TestRequestBuilder;
    /**
     * Permanently deletes an integration and all of its stored configuration, including any credentials held for it. This cannot be undone, and the deletion happens immediately — there is no confirmation step. An integration still in use by payment methods or other services is refused with 400 rather than deleted out from under them; disable it through the update endpoint first. To stop an integration working without losing its configuration, set isEnabled to false instead — this endpoint is for removing it altogether, and re-creating it means re-entering every secret, since none can be read back.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DeleteIntegrationResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DeleteIntegrationResponse | undefined>;
    /**
     * Retrieve detailed information about a specific integration including configuration and available fields. Secrets are not included in the response for security.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetIntegrationResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetIntegrationResponse | undefined>;
    /**
     * Changes an integration's name, its enabled flag, its configuration or its credentials. Send only the fields you are changing — at least one is required, and an omitted field is left as it was. This is also how an integration is switched off without losing its setup: send isEnabled false rather than deleting it. Secrets stay write-only through an update, so they can be replaced here but never read back; to replace credentials and confirm they work in one step, use POST .../integrations/{integrationId}/rotate-secrets instead. Nothing is verified against the provider here, so testConnectionRequired on the response is the signal to follow up with POST .../integrations/{integrationId}/test: it is set whenever secrets changed, or a configuration key that decides which endpoint the provider is reached at. If new credentials cannot be stored securely, the whole update is refused and the integration is left as it was.
     * @param body A partial update. At least one field must be supplied; anything omitted is left unchanged.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<UpdateIntegrationResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateIntegrationRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<UpdateIntegrationResponse | undefined>;
    /**
     * Permanently deletes an integration and all of its stored configuration, including any credentials held for it. This cannot be undone, and the deletion happens immediately — there is no confirmation step. An integration still in use by payment methods or other services is refused with 400 rather than deleted out from under them; disable it through the update endpoint first. To stop an integration working without losing its configuration, set isEnabled to false instead — this endpoint is for removing it altogether, and re-creating it means re-entering every secret, since none can be read back.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Retrieve detailed information about a specific integration including configuration and available fields. Secrets are not included in the response for security.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Changes an integration's name, its enabled flag, its configuration or its credentials. Send only the fields you are changing — at least one is required, and an omitted field is left as it was. This is also how an integration is switched off without losing its setup: send isEnabled false rather than deleting it. Secrets stay write-only through an update, so they can be replaced here but never read back; to replace credentials and confirm they work in one step, use POST .../integrations/{integrationId}/rotate-secrets instead. Nothing is verified against the provider here, so testConnectionRequired on the response is the signal to follow up with POST .../integrations/{integrationId}/test: it is set whenever secrets changed, or a configuration key that decides which endpoint the provider is reached at. If new credentials cannot be stored securely, the whole update is refused and the integration is left as it was.
     * @param body A partial update. At least one field must be supplied; anything omitted is left unchanged.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateIntegrationRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithIntegrationItemRequestBuilderUriTemplate = "{+baseurl}/api/organizations/{organizationId}/integrations/{integrationId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithIntegrationItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithIntegrationItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    rotateSecrets: {
        requestsMetadata: RotateSecretsRequestBuilderRequestsMetadata,
    },
    test: {
        requestsMetadata: TestRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithIntegrationItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithIntegrationItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDeleteIntegrationResponseFromDiscriminatorValue,
    },
    get: {
        uriTemplate: WithIntegrationItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetIntegrationResponseFromDiscriminatorValue,
    },
    put: {
        uriTemplate: WithIntegrationItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createUpdateIntegrationResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateIntegrationRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
